import { useState, useEffect } from "react";
import styled from "styled-components";

const Quote = () => {
  const [message, setMessage] = useState("");
  const [author, setAuthor] = useState("");

  const getRandomQuote = () => {
    fetch("https://api.quotable.io/random")
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setMessage(data?.content);
        setAuthor(data?.author);
      });
  };
  useEffect(() => {
    getRandomQuote();
  }, []);
  return (
    <QuoteBox  data-aos="fade-up" data-aos-delay="400" className="nl-container">
      <div className="nl-wrapper">
        <h4>"{message}"</h4>
        <p>{author}</p>
      </div>
    </QuoteBox>
  );
};
const QuoteBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5rem;
  text-align: center;
  .nl-wrapper {
    background-color: #222222;
    width: fit-content;
    max-width: 80%;
    padding: 1.5rem;
    border-radius: 10px;
    box-shadow: inset #000000 0px 0px 15px 2px;
    }
  h4 {
    font-size: 1.2rem;
    font-weight: 400;
    color: var(--text-light);
    font-style: italic;
  }
  p {
    font-size: 1rem;
    font-weight: 600;
    letter-spacing: 2px;
    color: var(--text-light);
  }
`;

export default Quote;
